module.exports = "<div class=\"form-group\">\n  <p class=\"text-center\">{{text}}</p>\n</div>\n<input #inputt [ngClass]=\"{'glowing': this.glow}\" style=\"max-width: 70% !important; margin-left: auto; margin-right: auto;\" class=\"form-control col\" type=\"{{type}}\" name=\"{{for}}\"\n  id=\"{{for}}\" [(ngModel)]=\"this.model.Answer\" >"


//////////////////
// WEBPACK FOOTER
// C:/git/SynergiPartners 7-Eleven Screening/src/app/utility-components/dynamic-input/dynamic-input.component.html
// module id = ../../../../../src/app/utility-components/dynamic-input/dynamic-input.component.html
// module chunks = main